import styled from 'styled-components';

export const StyledDiagramContainer = styled.div`
  width: 100%;
  min-height: 540px;
  height: 540px;
  background-color: rgb(18, 18, 18);
  position: relative;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius.small};

  .vis-network {
    padding-bottom: 0.3rem;
    position: relative;
    padding-top: -0.5rem;
    height: 54rem !important;
  }

  .vis-network:focus {
    outline: none;
  }
`;

export const StyledOverlay = styled.div`
  position: absolute;
  min-height: 54rem;
  max-height: 54rem;
  width: 100%;
  border-top-right-radius: ${({ theme }) => theme.radius.small};
  border-top-left-radius: ${({ theme }) => theme.radius.small};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.95;
  background-color: #7f7f7f;
  z-index: 10;
`;

export const StyledNetworkLoaderWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  align-items: center;
`;

export const StyledOverlayHeader = styled.h3`
  color: ${({ theme }) => theme.colors.white};
`;

export const StyledOverlaySubHeader = styled.h4`
  color: ${({ theme }) => theme.colors.white};
`;
